import React, { useEffect, useState } from 'react'
import { Box, Button, TextField } from '@mui/material'

import { IContractDates } from '../../../Services/contractDates'

interface Props {
	contract: IContractDates | null
	saving: boolean
	onSave: (dates: { startAt?: string; endAt?: string }) => void
}

// Deux champs, et pas trois : l'anniversaire est le jour et le mois du début du
// contrat. Un champ de plus pour la même information laisserait l'opérateur
// saisir une période décalée sans que rien ne l'explique.

// #region ContractDatesForm
export const ContractDatesForm: React.FC<Props> = ({ contract, saving, onSave }) => {
	const [startAt, setStartAt] = useState('')
	const [endAt, setEndAt] = useState('')

	useEffect(() => {
		setStartAt(contract?.startAt || '')
		setEndAt(contract?.endAt || '')
	}, [contract])

	const dirty = startAt !== (contract?.startAt || '') || endAt !== (contract?.endAt || '')

	return (
		<Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
			<TextField
				label="Début du contrat"
				type="date"
				size="small"
				value={startAt}
				onChange={(e) => setStartAt(e.target.value)}
				InputLabelProps={{ shrink: true }}
				helperText="L’année de facturation court de cette date à la même date l’an suivant."
			/>
			<TextField
				label="Fin du contrat (facultative)"
				type="date"
				size="small"
				value={endAt}
				onChange={(e) => setEndAt(e.target.value)}
				InputLabelProps={{ shrink: true }}
				// ⚠️ Journée INCLUSE, et les droits se ferment le lendemain. Dit ici
				// parce que c'est la seule chose qui distingue une saisie juste d'une
				// saisie qui retire un jour au client.
				helperText="Dernier jour couvert. Vide = le contrat court. Au-delà, les droits produit se ferment."
			/>
			<Box>
				<Button
					variant="contained"
					size="small"
					disabled={!dirty || saving}
					onClick={() => onSave({ startAt, endAt })}
				>
					{saving ? 'Enregistrement…' : 'Enregistrer'}
				</Button>
			</Box>
		</Box>
	)
}

// #endregion
